import { toast } from "react-toastify";
import { ADD_SITE_IN_A_BOX_ITEM_FAILURE, ADD_SITE_IN_A_BOX_ITEM_REQUEST, ADD_SITE_IN_A_BOX_ITEM_SUCCESS, CLEAR_SITE_IN_A_BOX_ERROR, DELETE_SITE_IN_A_BOX_ITEM_FAILURE, DELETE_SITE_IN_A_BOX_ITEM_REQUEST, DELETE_SITE_IN_A_BOX_ITEM_SUCCESS, EDIT_SITE_IN_A_BOX_ITEM_FAILURE, EDIT_SITE_IN_A_BOX_ITEM_REQUEST, EDIT_SITE_IN_A_BOX_ITEM_SUCCESS, FETCH_SITE_IN_A_BOX_ITEM_FAILURE, FETCH_SITE_IN_A_BOX_ITEM_REQUEST, FETCH_SITE_IN_A_BOX_ITEM_SUCCESS, FETCH_SITE_IN_A_BOX_ITEMS_FAILURE, FETCH_SITE_IN_A_BOX_ITEMS_REQUEST, FETCH_SITE_IN_A_BOX_ITEMS_SUCCESS, GET_SITE_IN_A_BOX_DOC_URL, SEND_EMAIL_FAILURE, SEND_EMAIL_REQUEST, SEND_EMAIL_SUCCESS, SET_SITE_IN_A_BOX_CONNECTIVITY_DEFAULTS, SET_SITE_IN_A_BOX_FILTERS, SET_SITE_IN_A_BOX_PAGINATION, SET_SITE_IN_A_BOX_SITE_DETAILS, } from "./types";
function parseApiResponse(response) {
    return response?.data || response;
}
function buildUrlWithOrgId(path, orgId, extraParams) {
    const queryParams = new URLSearchParams();
    if (orgId !== undefined && orgId !== null && String(orgId) !== "") {
        queryParams.append("org_id", String(orgId));
    }
    if (extraParams) {
        Object.entries(extraParams).forEach(([key, value]) => {
            queryParams.append(key, value);
        });
    }
    return `${path}${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
}
function parseConnectivityListPayload(connData) {
    const c = connData;
    const nested = c?.data;
    const raw = c?.connectivityList ?? nested?.connectivityList ?? [];
    if (!Array.isArray(raw)) {
        return { list: [], first: null };
    }
    const list = raw
        .filter((x) => Boolean(x && typeof x === "object"))
        .map((x) => x);
    const first = list[0] ?? null;
    return { list, first };
}
export function createSiteInABoxActions(apiHandler) {
    async function refreshConnectivityListFromApi(orgId, dispatch) {
        try {
            const url = buildUrlWithOrgId("/site-in-a-box", orgId, {
                aggregate: "org-defaults",
            });
            const connRes = await apiHandler("get", url);
            const data = parseApiResponse(connRes);
            const nested = data?.data;
            const rawList = data?.connectivityList ?? nested?.connectivityList ?? [];
            const { list, first } = parseConnectivityListPayload({
                connectivityList: rawList,
            });
            dispatch({
                type: SET_SITE_IN_A_BOX_CONNECTIVITY_DEFAULTS,
                payload: {
                    connectivityDefaults: first,
                    connectivityList: list,
                },
            });
        }
        catch {
            /* keep existing connectivity state */
        }
    }
    const fetchSiteInABoxItems = (params = {}) => async (dispatch) => {
        dispatch({
            type: FETCH_SITE_IN_A_BOX_ITEMS_REQUEST,
            payload: { loading: true },
        });
        try {
            const queryParams = new URLSearchParams();
            const page = params.page;
            const perPage = params.per_page ??
                params.perPage;
            if (page)
                queryParams.append("page", String(page));
            if (perPage)
                queryParams.append("per_page", String(perPage));
            const filters = params;
            for (const key of [
                "entity",
                "address",
                "site_code",
                "reference_id",
                "country",
                "site_type",
                "org_id",
            ]) {
                const value = filters[key];
                if (typeof value === "string" && value)
                    queryParams.append(key, value);
            }
            const url = `/site-in-a-box${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
            const response = await apiHandler("get", url);
            const data = parseApiResponse(response);
            const total = data?.total ?? data?.data?.total ?? 0;
            const resolvedPerPage = perPage ?? 20;
            dispatch({
                type: FETCH_SITE_IN_A_BOX_ITEMS_SUCCESS,
                payload: {
                    items: data?.site_in_a_boxes ||
                        data?.data?.site_in_a_boxes ||
                        data?.data ||
                        data ||
                        [],
                    total,
                    pagination: data?.pagination ||
                        data?.data?.pagination || {
                        page: page || 1,
                        per_page: resolvedPerPage,
                        total_pages: Math.ceil(total / resolvedPerPage),
                        total_count: total,
                    },
                    loading: false,
                },
            });
        }
        catch (error) {
            const errMessage = error?.message || "Failed to fetch site-in-a-box items";
            toast.error(errMessage);
            dispatch({
                type: FETCH_SITE_IN_A_BOX_ITEMS_FAILURE,
                payload: { error: errMessage, loading: false },
            });
        }
    };
    const fetchSiteInABoxItem = (id) => async (dispatch) => {
        dispatch({
            type: FETCH_SITE_IN_A_BOX_ITEM_REQUEST,
            payload: { loading: true },
        });
        try {
            const response = await apiHandler("get", `/site-in-a-box/${id}`);
            const data = parseApiResponse(response);
            dispatch({
                type: FETCH_SITE_IN_A_BOX_ITEM_SUCCESS,
                payload: {
                    item: data?.site_in_a_box || data?.data?.site_in_a_box || data,
                    loading: false,
                },
            });
        }
        catch (error) {
            const errMessage = error?.message || "Failed to fetch site-in-a-box item";
            toast.error(errMessage);
            dispatch({
                type: FETCH_SITE_IN_A_BOX_ITEM_FAILURE,
                payload: { error: errMessage, loading: false },
            });
        }
    };
    const addSiteInABoxItem = (itemData, orgId) => async (dispatch) => {
        dispatch({
            type: ADD_SITE_IN_A_BOX_ITEM_REQUEST,
            payload: { loading: true },
        });
        try {
            const url = buildUrlWithOrgId("/site-in-a-box", orgId);
            const response = await apiHandler("post", url, itemData);
            const data = parseApiResponse(response);
            const savedItem = data?.site_in_a_box || data?.data?.site_in_a_box || data;
            dispatch({
                type: ADD_SITE_IN_A_BOX_ITEM_SUCCESS,
                payload: {
                    item: savedItem,
                    loading: false,
                },
            });
            await refreshConnectivityListFromApi(orgId, dispatch);
            toast.success("Site in a box item added successfully");
            return savedItem;
        }
        catch (error) {
            const errMessage = error?.message || "Failed to add site in a box item";
            toast.error(errMessage);
            dispatch({
                type: ADD_SITE_IN_A_BOX_ITEM_FAILURE,
                payload: { error: errMessage, loading: false },
            });
            return null;
        }
    };
    const fetchSiteInABoxOrgDefaults = (orgId) => async (dispatch) => {
        try {
            const url = buildUrlWithOrgId("/site-in-a-box", orgId, {
                aggregate: "org-defaults",
            });
            const res = await apiHandler("get", url);
            const data = parseApiResponse(res);
            const nested = data?.data;
            const site_details = data?.siteDetails ?? nested?.siteDetails ?? null;
            const rawList = data?.connectivityList ?? nested?.connectivityList ?? [];
            const connData = { connectivityList: rawList };
            const { list, first: connectivityDefaults } = parseConnectivityListPayload(connData);
            dispatch({
                type: SET_SITE_IN_A_BOX_SITE_DETAILS,
                payload: { siteDetails: site_details },
            });
            dispatch({
                type: SET_SITE_IN_A_BOX_CONNECTIVITY_DEFAULTS,
                payload: {
                    connectivityDefaults,
                    connectivityList: list,
                },
            });
        }
        catch {
            /* keep existing defaults */
        }
    };
    const editSiteInABoxItem = (id, itemData, orgId) => async (dispatch) => {
        dispatch({
            type: EDIT_SITE_IN_A_BOX_ITEM_REQUEST,
            payload: { loading: true },
        });
        try {
            const url = buildUrlWithOrgId(`/site-in-a-box/${id}`, orgId);
            const response = await apiHandler("put", url, itemData);
            const data = parseApiResponse(response);
            const savedItem = data?.site_in_a_box || data?.data?.site_in_a_box || data;
            dispatch({
                type: EDIT_SITE_IN_A_BOX_ITEM_SUCCESS,
                payload: {
                    item: savedItem,
                    loading: false,
                },
            });
            await refreshConnectivityListFromApi(orgId, dispatch);
            await dispatch(fetchSiteInABoxItem(id));
            toast.success("Site in a box item updated successfully");
            return savedItem;
        }
        catch (error) {
            const errMessage = error?.message || "Failed to update site in a box item";
            toast.error(errMessage);
            dispatch({
                type: EDIT_SITE_IN_A_BOX_ITEM_FAILURE,
                payload: { error: errMessage, loading: false },
            });
            return null;
        }
    };
    const patchSiteInABoxItem = (id, itemData, orgId) => async (dispatch) => {
        dispatch({
            type: EDIT_SITE_IN_A_BOX_ITEM_REQUEST,
            payload: { loading: true },
        });
        try {
            const url = buildUrlWithOrgId(`/site-in-a-box/${id}`, orgId);
            const response = await apiHandler("patch", url, itemData);
            const data = parseApiResponse(response);
            const savedItem = data?.site_in_a_box || data?.data?.site_in_a_box || data;
            dispatch({
                type: EDIT_SITE_IN_A_BOX_ITEM_SUCCESS,
                payload: {
                    item: savedItem,
                    loading: false,
                },
            });
            await refreshConnectivityListFromApi(orgId, dispatch);
            await dispatch(fetchSiteInABoxItem(id));
            toast.success("Site in a box item updated successfully");
            return savedItem;
        }
        catch (error) {
            const errMessage = error?.message || "Failed to patch site in a box item";
            toast.error(errMessage);
            dispatch({
                type: EDIT_SITE_IN_A_BOX_ITEM_FAILURE,
                payload: { error: errMessage, loading: false },
            });
            return null;
        }
    };
    const deleteSiteInABoxItem = (id, orgId) => async (dispatch) => {
        dispatch({
            type: DELETE_SITE_IN_A_BOX_ITEM_REQUEST,
            payload: { loading: true },
        });
        try {
            const url = buildUrlWithOrgId(`/site-in-a-box/${id}`, orgId);
            await apiHandler("del", url, {});
            dispatch({
                type: DELETE_SITE_IN_A_BOX_ITEM_SUCCESS,
                payload: { id, loading: false },
            });
            await refreshConnectivityListFromApi(orgId, dispatch);
            toast.success("Site in a box item deleted successfully");
            return true;
        }
        catch (error) {
            const errMessage = error?.message || "Failed to delete site in a box item";
            toast.error(errMessage);
            dispatch({
                type: DELETE_SITE_IN_A_BOX_ITEM_FAILURE,
                payload: { error: errMessage, loading: false },
            });
            return false;
        }
    };
    const getSiteInABoxSowPdf = (id) => async (dispatch) => {
        try {
            dispatch({
                type: GET_SITE_IN_A_BOX_DOC_URL,
                payload: { docUrl: null, loading: true },
            });
            const response = await apiHandler("get", `/site-in-a-box/get-doc-url/${id}`);
            const data = parseApiResponse(response);
            const docUrl = data?.doc_url ??
                response?.data?.doc_url ??
                null;
            dispatch({
                type: GET_SITE_IN_A_BOX_DOC_URL,
                payload: {
                    docUrl,
                    loading: false,
                },
            });
            return docUrl;
        }
        catch (error) {
            const errMessage = error?.message || "Failed to fetch document URL";
            toast.error(errMessage);
            dispatch({
                type: GET_SITE_IN_A_BOX_DOC_URL,
                payload: { docUrl: null, loading: false },
            });
            return null;
        }
    };
    const authoriseSiteInABox = (id, email, poNumber) => async (dispatch) => {
        try {
            dispatch({
                type: SEND_EMAIL_REQUEST,
                payload: { loading: true },
            });
            const response = await apiHandler("post", `/site-in-a-box/authorize/${encodeURIComponent(String(id))}`, {
                email,
                po_number: poNumber,
            });
            const data = parseApiResponse(response);
            if (data?.site_in_a_box != null) {
                throw new Error("Authorisation failed: a new quote was created instead of updating the existing one");
            }
            if (data?.status !== "ordered") {
                throw new Error(data?.message ??
                    "Authorisation did not update the quote to Ordered status");
            }
            const resolvedId = data.site_in_a_box_id ?? id;
            dispatch({
                type: SEND_EMAIL_SUCCESS,
                payload: {
                    loading: false,
                    id: resolvedId,
                    status: data.status,
                    po_number: data.po_number ?? poNumber.trim(),
                },
            });
            toast.success("Site in a Box authorised successfully");
            return true;
        }
        catch (error) {
            const errMessage = error?.message || "Failed to authorise Site in a Box";
            toast.error(errMessage);
            dispatch({
                type: SEND_EMAIL_FAILURE,
                payload: { error: errMessage, loading: false },
            });
            return false;
        }
    };
    const sendEmail = (id, email) => async (dispatch) => {
        try {
            dispatch({
                type: SEND_EMAIL_REQUEST,
                payload: { loading: true },
            });
            const response = await apiHandler("post", `/site-in-a-box/send-email/${id}`, { email });
            const data = parseApiResponse(response);
            dispatch({
                type: SEND_EMAIL_SUCCESS,
                payload: {
                    loading: false,
                    id,
                    ...(data?.status != null ? { status: data.status } : {}),
                },
            });
            toast.success("Statement of Work email sent successfully");
            return true;
        }
        catch (error) {
            const errMessage = error?.message || "Failed to send email";
            toast.error(errMessage);
            dispatch({
                type: SEND_EMAIL_FAILURE,
                payload: { error: errMessage, loading: false },
            });
            return false;
        }
    };
    const setSiteInABoxPagination = (pagination) => ({
        type: SET_SITE_IN_A_BOX_PAGINATION,
        payload: pagination,
    });
    const setSiteInABoxFilters = (filters) => ({
        type: SET_SITE_IN_A_BOX_FILTERS,
        payload: filters,
    });
    const clearSiteInABoxError = () => ({
        type: CLEAR_SITE_IN_A_BOX_ERROR,
    });
    return {
        fetchSiteInABoxItems,
        fetchSiteInABoxItem,
        addSiteInABoxItem,
        fetchSiteInABoxOrgDefaults,
        editSiteInABoxItem,
        patchSiteInABoxItem,
        deleteSiteInABoxItem,
        getSiteInABoxSowPdf,
        authoriseSiteInABox,
        sendEmail,
        setSiteInABoxPagination,
        setSiteInABoxFilters,
        clearSiteInABoxError,
    };
}
